/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GroupEventModel,
  GroupServiceGetManyResponse,
  GroupServiceGetResponse,
  GroupServiceSearchByPartialPolicyNumberResponse,
} from '../models/index';
import {
    GroupEventModelFromJSON,
    GroupEventModelToJSON,
    GroupServiceGetManyResponseFromJSON,
    GroupServiceGetManyResponseToJSON,
    GroupServiceGetResponseFromJSON,
    GroupServiceGetResponseToJSON,
    GroupServiceSearchByPartialPolicyNumberResponseFromJSON,
    GroupServiceSearchByPartialPolicyNumberResponseToJSON,
} from '../models/index';

export interface GroupApiApiGroupAssignToMePostRequest {
    timePeriodDate?: Date;
    groupId?: string;
}

export interface GroupApiApiGroupGetGetRequest {
    timePeriodDate?: Date;
    policyNumber?: string;
}

export interface GroupApiApiGroupGetGroupEventsGetRequest {
    timePeriodDate?: Date;
    policyNumber?: string;
}

export interface GroupApiApiGroupSearchByPartialPolicyNumberGetRequest {
    partialPolicyNumber?: string;
}

export interface GroupApiApiGroupSetAvaialableForRRPostRequest {
    timePeriodDate?: Date;
    groupId?: string;
    avaiableForRR?: boolean;
}

export interface GroupApiApiGroupSetCompletedPostRequest {
    timePeriodDate?: Date;
    groupId?: string;
    completed?: boolean;
}

/**
 * 
 */
export class GroupApi extends runtime.BaseAPI {

    /**
     */
    async apiGroupAssignToMePostRaw(requestParameters: GroupApiApiGroupAssignToMePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['timePeriodDate'] != null) {
            formParams.append('TimePeriodDate', (requestParameters['timePeriodDate'] as any).toISOString());
        }

        if (requestParameters['groupId'] != null) {
            formParams.append('GroupId', requestParameters['groupId'] as any);
        }


        let urlPath = `/api/Group/AssignToMe`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async apiGroupAssignToMePost(requestParameters: GroupApiApiGroupAssignToMePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.apiGroupAssignToMePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiGroupGetGetRaw(requestParameters: GroupApiApiGroupGetGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupServiceGetResponse>> {
        const queryParameters: any = {};

        if (requestParameters['timePeriodDate'] != null) {
            queryParameters['TimePeriodDate'] = (requestParameters['timePeriodDate'] as any).toISOString();
        }

        if (requestParameters['policyNumber'] != null) {
            queryParameters['PolicyNumber'] = requestParameters['policyNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/Group/Get`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupServiceGetResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiGroupGetGet(requestParameters: GroupApiApiGroupGetGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupServiceGetResponse> {
        const response = await this.apiGroupGetGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiGroupGetGroupEventsGetRaw(requestParameters: GroupApiApiGroupGetGroupEventsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GroupEventModel>>> {
        const queryParameters: any = {};

        if (requestParameters['timePeriodDate'] != null) {
            queryParameters['TimePeriodDate'] = (requestParameters['timePeriodDate'] as any).toISOString();
        }

        if (requestParameters['policyNumber'] != null) {
            queryParameters['PolicyNumber'] = requestParameters['policyNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/Group/GetGroupEvents`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GroupEventModelFromJSON));
    }

    /**
     */
    async apiGroupGetGroupEventsGet(requestParameters: GroupApiApiGroupGetGroupEventsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GroupEventModel>> {
        const response = await this.apiGroupGetGroupEventsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiGroupGetGroupsWithOpenRequestsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GroupServiceGetManyResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/Group/GetGroupsWithOpenRequests`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GroupServiceGetManyResponseFromJSON));
    }

    /**
     */
    async apiGroupGetGroupsWithOpenRequestsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GroupServiceGetManyResponse>> {
        const response = await this.apiGroupGetGroupsWithOpenRequestsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiGroupSearchByPartialPolicyNumberGetRaw(requestParameters: GroupApiApiGroupSearchByPartialPolicyNumberGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GroupServiceSearchByPartialPolicyNumberResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['partialPolicyNumber'] != null) {
            queryParameters['PartialPolicyNumber'] = requestParameters['partialPolicyNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/Group/SearchByPartialPolicyNumber`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GroupServiceSearchByPartialPolicyNumberResponseFromJSON));
    }

    /**
     */
    async apiGroupSearchByPartialPolicyNumberGet(requestParameters: GroupApiApiGroupSearchByPartialPolicyNumberGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GroupServiceSearchByPartialPolicyNumberResponse>> {
        const response = await this.apiGroupSearchByPartialPolicyNumberGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiGroupSetAvaialableForRRPostRaw(requestParameters: GroupApiApiGroupSetAvaialableForRRPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['timePeriodDate'] != null) {
            formParams.append('TimePeriodDate', (requestParameters['timePeriodDate'] as any).toISOString());
        }

        if (requestParameters['groupId'] != null) {
            formParams.append('GroupId', requestParameters['groupId'] as any);
        }

        if (requestParameters['avaiableForRR'] != null) {
            formParams.append('AvaiableForRR', requestParameters['avaiableForRR'] as any);
        }


        let urlPath = `/api/Group/SetAvaialableForRR`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async apiGroupSetAvaialableForRRPost(requestParameters: GroupApiApiGroupSetAvaialableForRRPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.apiGroupSetAvaialableForRRPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiGroupSetCompletedPostRaw(requestParameters: GroupApiApiGroupSetCompletedPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['timePeriodDate'] != null) {
            formParams.append('TimePeriodDate', (requestParameters['timePeriodDate'] as any).toISOString());
        }

        if (requestParameters['groupId'] != null) {
            formParams.append('GroupId', requestParameters['groupId'] as any);
        }

        if (requestParameters['completed'] != null) {
            formParams.append('Completed', requestParameters['completed'] as any);
        }


        let urlPath = `/api/Group/SetCompleted`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async apiGroupSetCompletedPost(requestParameters: GroupApiApiGroupSetCompletedPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.apiGroupSetCompletedPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
